module.exports = __webpack_public_path__ + "static/media/tw.26cc9d59.svg";